import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { META_PIXEL_ID } from "../../config/analytics";

const isProductionEnvironment = () => {
  const environment = process.env.REACT_APP_ENV;
  return environment === 'prod' || environment === 'production';
};

const isValidEmail = (value) =>
  typeof value === 'string' &&
  value.length > 0 &&
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim().toLowerCase());

const MetaPixel = () => {
  const isProduction = isProductionEnvironment();
  const externalId = sessionStorage.getItem("externalId");
  const email = localStorage.getItem('email');
  const validEmail = isValidEmail(email);
  const initParams = { external_id: externalId ?? '' };
  if (validEmail) initParams.em = email;
  const initParamsStr = JSON.stringify(initParams);

  useEffect(() => {
    if (!isProduction || !META_PIXEL_ID || typeof window === 'undefined' || !window.fbq) return;
    const params = { external_id: sessionStorage.getItem('externalId') ?? '' };
    const currentEmail = localStorage.getItem('email');
    if (isValidEmail(currentEmail)) params.em = currentEmail;
    window.fbq('init', META_PIXEL_ID, params);
  }, [isProduction, email, externalId]);

  if (!isProduction) return null;

  return (
    <Helmet>
      <script id="facebook-pixel-script" type="text/javascript">
        {`
          !function(f,b,e,v,n,t,s) {
            if(f.fbq)return;
            n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;
            n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];
            t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s);
          }(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${META_PIXEL_ID}', ${initParamsStr});
          fbq.disablePushState = true
          fbq.allowDuplicatePageViews = true
        `}
      </script>
      <noscript>
        {`
          <img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />
        `}
      </noscript>
    </Helmet>
  );
};

export default MetaPixel;
